import React from "react";

const PageNotFound = () => {
  return (
    <>
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        className="text-white fw-bold"
      >
        <div>
          <h1>404</h1>
          <h3>Page Not Found</h3>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
